module.exports = __webpack_public_path__ + "img/233.acd6aa84.jpg";